// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3ivAX","range":"MonthRangeSwitch_range__2e9K5","disabled":"MonthRangeSwitch_disabled__21Dj5"};